import { html, type Html, Page, rune } from 'rune-ts';
import { MembershipUtilS } from '../../../../../../services/MarppleShop/features/Membership/outbound/share';
import { MyPagePayMethodWidget } from '@marpple/mco-membership-ui';
import { EXCLUDE_MAKER_MODULE } from '../../../../../../services/MarppleShop/shared/constant';
import klass from './MembershipPayMethod.module.scss';
import { MyMembershipTabData } from '../../MembershipList/S/type';
import { MShopUtilF } from '../../../../Util/F/Function/module/MShopUtilF';
import { createOnClickPersonalInfoOutsourcing } from './terms/PersonalInfoOutsourcingTerms';
import { createOnClickThirdPartyConsent } from './terms/ThirdPartyConsentTerms';
import { createOnClickInicisTerms } from './terms/InicisTerms';
import { MembershipErrorEnable } from '../../../../../../services/MarppleShop/features/Membership/error/error_enable';
import { getActivatedSdkWithEvent } from '../../../../../../services/MarppleShop/features/Membership/util';
import { ConfigSentryF } from '../../../../../Config/Sentry/F/Function/module/ConfigSentryF';

export class MembershipPayMethod extends Page<MyMembershipTabData> {
  private _membershipErrorEnable = new MembershipErrorEnable(this);

  protected override template(): Html {
    return html` <div class="${klass.root} ${EXCLUDE_MAKER_MODULE}"></div>`;
  }

  override async onMount() {
    try {
      const client = await getActivatedSdkWithEvent(this.data.membership_token);

      const widget = new MyPagePayMethodWidget({
        client,
        onMoveMyPageMembershipSupportPage: MembershipUtilS.onGoBackToMembershipSupportListButtonClick,
        onClickPersonalInfoOutsourcing: createOnClickPersonalInfoOutsourcing(),
        onClickThirdPartyConsent: createOnClickThirdPartyConsent(),
        onClickInicisTerms: createOnClickInicisTerms(),
        isMobile: this.isMobile,
        toggleSpinner: MembershipUtilS.toggleSpinner,
        onError: this._membershipErrorEnable.onError,
        isApp: this.isApp,
        onScrollLock: MShopUtilF.bodyFixed$,
      });

      widget.render(this.element());
    } catch (e) {
      ConfigSentryF.error(e);
      await this._membershipErrorEnable.openWidgetRenderErrorModal();
    }
  }

  get isMobile(): boolean {
    return this.data.layout_options.is_mobile;
  }

  get isApp(): boolean {
    return MShopUtilF.isApp();
  }
}
